import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Package, DownloadCloud, Users } from 'lucide-react';
interface SoftwareDistributionProps {
  onLogout: () => void;
}
export function SoftwareDistribution({
  onLogout
}: SoftwareDistributionProps) {
  return <MainLayout title="Softwareverteilung (MDM)" onLogout={onLogout} data-id="element-667">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-668">
        <Card title="Software Pakete" className="lg:col-span-2" data-id="element-669">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-670">
            {[{
            name: 'Microsoft Office 365',
            version: 'v16.0.1',
            size: '2.4 GB',
            type: 'Productivity'
          }, {
            name: 'Adobe Acrobat Reader',
            version: '2023.001',
            size: '450 MB',
            type: 'Utility'
          }, {
            name: 'Google Chrome Enterprise',
            version: 'v118',
            size: '120 MB',
            type: 'Browser'
          }, {
            name: '7-Zip',
            version: '23.01',
            size: '5 MB',
            type: 'Utility'
          }, {
            name: 'TeamViewer Host',
            version: 'v15',
            size: '80 MB',
            type: 'Support'
          }, {
            name: 'VLC Media Player',
            version: '3.0.18',
            size: '40 MB',
            type: 'Media'
          }].map((app, idx) => <div key={idx} className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-teal-500 transition-colors" data-id="element-671">
                <div className="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center mr-4" data-id="element-672">
                  <Package className="h-5 w-5 text-slate-600" data-id="element-673" />
                </div>
                <div className="flex-1" data-id="element-674">
                  <h4 className="font-medium text-slate-900" data-id="element-675">{app.name}</h4>
                  <div className="flex items-center gap-2 text-xs text-slate-500" data-id="element-676">
                    <span data-id="element-677">{app.version}</span>
                    <span data-id="element-678">•</span>
                    <span data-id="element-679">{app.size}</span>
                  </div>
                </div>
                <Button size="sm" variant="ghost" icon={<DownloadCloud className="h-4 w-4" data-id="element-681" />} data-id="element-680">
                  Deploy
                </Button>
              </div>)}
          </div>
        </Card>

        <div className="space-y-6" data-id="element-682">
          <Card title="Deployment Status" data-id="element-683">
            <div className="space-y-4" data-id="element-684">
              <div data-id="element-685">
                <div className="flex justify-between text-sm mb-1" data-id="element-686">
                  <span className="font-medium" data-id="element-687">
                    Chrome Update (Alle Clients)
                  </span>
                  <span className="text-slate-500" data-id="element-688">85%</span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-689">
                  <div className="bg-teal-500 h-2 rounded-full" style={{
                  width: '85%'
                }} data-id="element-690"></div>
                </div>
              </div>

              <div data-id="element-691">
                <div className="flex justify-between text-sm mb-1" data-id="element-692">
                  <span className="font-medium" data-id="element-693">Office 365 Rollout</span>
                  <span className="text-slate-500" data-id="element-694">42%</span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-695">
                  <div className="bg-blue-500 h-2 rounded-full" style={{
                  width: '42%'
                }} data-id="element-696"></div>
                </div>
              </div>
            </div>
          </Card>

          <Card title="MDM Gruppen" data-id="element-697">
            <div className="space-y-2" data-id="element-698">
              <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded cursor-pointer" data-id="element-699">
                <div className="flex items-center gap-3" data-id="element-700">
                  <Users className="h-4 w-4 text-slate-500" data-id="element-701" />
                  <span className="text-sm" data-id="element-702">Alle Windows Clients</span>
                </div>
                <Badge variant="secondary" data-id="element-703">142</Badge>
              </div>
              <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded cursor-pointer" data-id="element-704">
                <div className="flex items-center gap-3" data-id="element-705">
                  <Users className="h-4 w-4 text-slate-500" data-id="element-706" />
                  <span className="text-sm" data-id="element-707">Vertrieb Notebooks</span>
                </div>
                <Badge variant="secondary" data-id="element-708">28</Badge>
              </div>
              <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded cursor-pointer" data-id="element-709">
                <div className="flex items-center gap-3" data-id="element-710">
                  <Users className="h-4 w-4 text-slate-500" data-id="element-711" />
                  <span className="text-sm" data-id="element-712">Management</span>
                </div>
                <Badge variant="secondary" data-id="element-713">12</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </MainLayout>;
}